module.exports = __webpack_public_path__ + "img/ch-mazurelle.e725f699.png";